var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showDialog
    ? _c("div", { staticClass: "dialog-container" }, [
        _c("div", { staticClass: "dialog-background" }),
        _c("div", { staticClass: "dialog-message-container" }, [
          _c(
            "header",
            { class: ["header-container"] },
            [
              _c("span", { staticClass: "header-title" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
              _c("v-spacer"),
              _c("span", {
                staticClass: "lf-icon-close close-icon",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.closeDialog.apply(null, arguments)
                  },
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "message-container" }, [
            _c(
              "form",
              {
                staticClass: "container-form save-form",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.actionDialog.apply(null, arguments)
                  },
                },
              },
              [
                _c("v-col", [
                  _c("div", { staticClass: "label-text" }, [
                    _vm._v(_vm._s(_vm.nameLabel)),
                  ]),
                  _c("span", { staticClass: "required-field" }, [_vm._v("*")]),
                  _c("div", { staticClass: "lf-textfield" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.name,
                          expression: "name",
                        },
                      ],
                      class: ["lf-textfield-input"],
                      domProps: { value: _vm.name },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.name = $event.target.value
                          },
                          _vm.checkFields,
                        ],
                      },
                    }),
                  ]),
                ]),
                _c("v-col", [
                  _c("div", { staticClass: "label-text" }, [
                    _vm._v(_vm._s(_vm.descriptionLabel)),
                  ]),
                  _c("div", { staticClass: "lf-textfield" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.description,
                          expression: "description",
                        },
                      ],
                      class: ["lf-textarea"],
                      attrs: { maxlength: _vm.maxlength },
                      domProps: { value: _vm.description },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.description = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _vm.maxlength
                    ? _c(
                        "div",
                        {
                          class: [
                            { "limit-reached": _vm.maxNumberCharactersExceed },
                            "counter",
                          ],
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.description ? _vm.description.length : "0"
                            ) +
                              " / " +
                              _vm._s(_vm.maxlength)
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "actions-container" }, [
            _c(
              "button",
              {
                staticClass: "button secondary-action-button",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.closeDialog.apply(null, arguments)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.cancelButton))]
            ),
            _c(
              "button",
              {
                staticClass: "button main-action-button",
                attrs: { disabled: _vm.disableSave },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.actionDialog.apply(null, arguments)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.saveButton))]
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }